import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  startApplication: false,
  courseDetailId: null,
  isCourseDetails: false,
  isAddApplication: false,
  isAddQualification: false,
  editQualificationData: null as any | null,
};

const educationSlice = createSlice({
  name: "education-slice",
  initialState,
  reducers: {
    setCourseDetailId: (state, action) => {
      state.courseDetailId = action.payload;
    },
    setIsCourseDetails: (state, action) => {
      state.isCourseDetails = action.payload;
    },
    setStartApplication: (state, action) => {
      state.startApplication = action.payload;

      if (state.startApplication) {
        state.isCourseDetails = false;
      }
    },
    setIsAddQualification: (state, action: PayloadAction<boolean>) => {
      state.isAddQualification = action.payload;
    },
    setEditQualificationData: (state, action: PayloadAction<any | null>) => {
      state.editQualificationData = action.payload;
    },
  },
});

export const {
  setStartApplication,
  setIsAddQualification,
  setEditQualificationData,
  setIsCourseDetails,
  setCourseDetailId,
} = educationSlice.actions;
export default educationSlice.reducer;
